/* ==========================================================================
   stools2 — variant live update
   On option change inside [data-variants], find the matching variant and
   update price, compare, availability, variant id and image.
   Variant data (with pre-formatted money) lives in [data-variant-json].
   ========================================================================== */

(function () {
  function apply(root, variant) {
    const idInput = root.querySelector('[name="id"]');
    const priceEl = root.querySelector('[data-variant-price]');
    const compareEl = root.querySelector('[data-variant-compare]');
    const addBtn = root.querySelector('[data-variant-add]');
    const img = root.querySelector('[data-variant-image]');

    if (!variant) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-soldout') || 'Sold out';
      }
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = variant.price;
    if (compareEl) {
      if (variant.compare) { compareEl.textContent = variant.compare; compareEl.hidden = false; }
      else { compareEl.hidden = true; }
    }
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available
        ? (addBtn.getAttribute('data-add') || 'Add to cart')
        : (addBtn.getAttribute('data-soldout') || 'Sold out');
    }
    if (img && variant.image) img.src = variant.image;
  }

  function init(root) {
    const dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;
    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    root.addEventListener('change', function (e) {
      if (!e.target.matches('input[name^="options"]')) return;

      const chosen = [];
      root.querySelectorAll('input[name^="options"]:checked').forEach(function (i) { chosen.push(i.value); });

      const variant = variants.find(function (v) {
        return v.options.length === chosen.length && v.options.every(function (o, idx) { return o === chosen[idx]; });
      });
      apply(root, variant);

      // update selected swatch visual within the changed group
      const group = e.target.name;
      root.querySelectorAll('input[name="' + (window.CSS && CSS.escape ? CSS.escape(group) : group) + '"]').forEach(function (i) {
        const label = i.closest('.pdp__swatch, .quickview__swatch');
        if (label) label.classList.toggle('is-selected', i.checked);
      });
    });
  }

  document.querySelectorAll('[data-variants]').forEach(init);
})();
